import dayjs, { type Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { SYDNEY_TIMEZONE } from './constants';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.tz.setDefault(SYDNEY_TIMEZONE);

/**
 * The native DayJS add function does not work across DST changes
 *  This function works around that by adding the days to the date in the
 *  specified timezone without touching the MS count
 */
export const addDays = (dayJsDate: Dayjs, quantity: number) => {
  const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const clone = dayjs.tz(dayJsDate, timeZoneName);
  return clone.date(clone.date() + quantity).tz(timeZoneName, true);
};

/**
 * Calculates the latest Monday that is on or before the specified datetime
 *
 * @returns Dayjs object representing the target Monday
 */
export const getMondayOfWeek = (datetime: Dayjs): Dayjs => {
  const date = dayjs(datetime);

  const dayOfWeek = date.day(); // Sunday = 0, Monday = 1, ..., Saturday = 6
  const daysFromMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Calculate how many days to subtract to get to Monday

  return date.subtract(daysFromMonday, 'day').startOf('day');
};
